module.exports = __webpack_public_path__ + "img/004-management.6f7909ae.png";